import { useState } from 'react';
import { advanceSoon, ContinueButton, Followup, BackButton } from './common.jsx';

// Yes/No with auto-advance, unless a Yes reveals an inline follow-up.
export default function YesNo({ item, answers, setAnswer, onAdvance }) {
  const val = answers[item.id];
  const revealsFollowup = !!item.followup;
  // Suppresses the Continue button during the brief auto-advance window so it doesn't
  // flash into view between the click and the next screen. Stays false on resume (where
  // the answer is pre-set), so a returning user still gets an explicit Continue.
  const [advancing, setAdvancing] = useState(false);

  const choose = (v) => {
    setAnswer(item.id, v);
    if (v === 'Yes' && revealsFollowup) return; // wait for the follow-up + Continue
    setAdvancing(true);
    advanceSoon(onAdvance);
  };

  return (
    <>
      <h1>{item.label}</h1>
      <div className="ynw">
        {['Yes', 'No'].map((v) => (
          <button key={v} className={`yn${val === v ? ' sel' : ''}`} onClick={() => choose(v)}>
            {val === v ? '✓ ' : ''}{v}
          </button>
        ))}
      </div>
      {val === 'Yes' && item.followup ? (
        <Followup fu={item.followup} answers={answers} setAnswer={setAnswer} onAdvance={onAdvance} />
      ) : val !== undefined && !advancing ? (
        // Already answered (e.g. resumed) — show an explicit Continue so it's clear how to
        // proceed, since picking an answer is what normally auto-advances.
        <ContinueButton onClick={onAdvance} />
      ) : (
        <BackButton />
      )}
    </>
  );
}
